import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hg_token");
      localStorage.removeItem("hg_user");
    }
    return Promise.reject(err);
  }
);

export const streamChat = async ({ message, city_slug, property_id, session_id, onDelta, onDone }) => {
  const token = localStorage.getItem("hg_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  const resp = await fetch(`${API}/chat`, {
    method: "POST",
    credentials: "include",
    headers,
    body: JSON.stringify({ message, city_slug, property_id, session_id }),
  });
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    const err = new Error(typeof body.detail === "string" ? body.detail : "Chat error");
    err.status = resp.status;
    throw err;
  }
  const reader = resp.body.getReader();
  const dec = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += dec.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data:\s?/, "");
      if (line === "[DONE]") { onDone?.(); return; }
      if (line.startsWith("[error]")) { onDelta?.(`\n\nError: ${line}`); onDone?.(); return; }
      onDelta?.(line);
    }
  }
  onDone?.();
};
